import React from 'react';
import styled from 'styled-components';
import { compose, layout, position, space } from 'styled-system';
import { getStyledSystemLayoutProps, getStyledSystemPositionProps, getStyledSystemSpaceProps } from '@equinor/opt-ui-core';
// Styled components
const Container = styled.div `
  position: relative;
  width: 100%;
  height: 100%;
`;
const Content = styled.div `
  position: absolute;
  width: inherit;
  height: inherit;
  overflow: auto;
  ${compose(space, layout, position)};
`;
// HOC Component
const ScrollableContent = ({ className = '', children, ...other }) => {
    const { ...spaceProps } = getStyledSystemSpaceProps(other);
    const { ...layoutProps } = getStyledSystemLayoutProps(other);
    const { ...positionProps } = getStyledSystemPositionProps(other);
    return (React.createElement(Container, { className: className ? `app-content__scrollable ${className}` : 'app-content__scrollable' },
        React.createElement(Content, { className: "app-content__scrollable-inner", ...spaceProps, ...layoutProps, ...positionProps }, children)));
};
export default ScrollableContent;
